import { z } from 'zod';
import { createSortablePaginationSchema } from '../shared/index.js';
export const seatApplicationReviewerSearchSchema = createSortablePaginationSchema([
    'createdAt',
]).extend({
    status: z
        .enum([
        'draft',
        'pending',
        'review',
        'nominated',
        'confirmed',
        'declined',
        'withdrawn',
        'archived',
    ])
        .optional(),
    quickSearch: z.string().optional(),
});
